// عناصر التنقل الموحّدة لبوابة ولي الأمر — تُستخدم في القائمة السفلية (جوال) والقائمة العلوية (كمبيوتر)
export const parentNavigation = [
  { name: 'الرئيسية', href: '/parent', icon: 'home' },
  { name: 'أبنائي', href: '/parent/children', icon: 'users' },
  { name: 'استكشاف', href: '/parent/explore', icon: 'search' },
  { name: 'المدفوعات', href: '/parent/payments', icon: 'wallet' },
  { name: 'حسابي', href: '/parent/account', icon: 'cog' },
];

export const PARENT_ROUTE_TITLES = {
  '/parent': 'الرئيسية',
  '/parent/children': 'أبنائي',
  '/parent/explore': 'استكشاف الأكاديميات',
  '/parent/payments': 'المدفوعات',
  '/parent/account': 'حسابي',
};

export const getParentRouteTitle = (pathname) => {
  if (PARENT_ROUTE_TITLES[pathname]) return PARENT_ROUTE_TITLES[pathname];
  if (pathname.startsWith('/parent/children/')) return 'ملف الابن';
  return 'بوابة ولي الأمر';
};
